/* eslint-disable no-template-curly-in-string */
// import styled from 'styled-components';
import { TextField, withStyles } from '@material-ui/core';
import { COLOR } from '../../assets/styles/colors';

export const InputTextStyled = withStyles((theme) => ({
  root: {
    marginBottom: 0,
    width: ({ width }) => `${width}%`,
    height: '45px',
    backgroundColor: '#FFFFFF',
    fontWeight: 'bold',
    fontSize: '16px',
    margin: '10px 0',
    [theme.breakpoints.up('md')]: {
      fontSize: '18px',
    },
    '& label + .MuiInput-formControl': {
      marginTop: '15px',
    },
    '& .MuiInputBase-input': {
      color: `${COLOR.GREY_2}`,
      fontSize: '16px',
      fontFamily: 'sans-serif',
      fontStyle: 'normal',
      fontWeight: 'normal',
      [theme.breakpoints.up('md')]: {
        fontSize: '18px',
      },
    },
    '& .MuiOutlinedInput-input': {
      // padding: '8.5px 14px',
    },
    '& .MuiOutlinedInput-root': {
      borderRadius: '6px',
      height: '100%',
      '& :focus': {
        outline: '0',
      },
      '& fieldset': {
        border: `1px solid ${COLOR.GREY_3}`,
      },
      '&:hover fieldset': {
        borderColor: 'none',
      },
      '&.Mui-focused fieldset': {
        border: `1px solid ${COLOR.GREY_3}`,
      },
    },
    '& .MuiInput-underline:hover:not(.Mui-disabled):before': {
      borderBottom: 'none',
    },
    '& .MuiInput-underline:before': {
      borderBottom: 'none !important',
      borderColor: 'none',
    },
    '& .MuiInput-underline:after': {
      borderBottom: 'none !important',
      borderColor: 'none',
    },
    '& label': {
      color: `${COLOR.GREY_2}`,
    },
    '& label.MuiInputLabel-shrink': {
      color: `${COLOR.GREY_2}`,
      transform: 'translate(14px, -6px)',
      fontSize: '16px',
    },
    '& legend': {
      width: 'max-content',
      '& span': {
        fontSize: '16px',
      },
    },
  },
}))(TextField);
